<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.type"
        placeholder="类型"
      >
        <el-option
          v-for="(item, i) in typeData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.tag"
        placeholder="标签"
      >
        <el-option
          v-for="(item, i) in tagData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="单位名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      filters: {},
      tagData: [],
      typeData: [],
    };
  },
  created() {
    this.getSysParamByTypes(["ORGANIZER_TYPE", "ORGANIZER_TAG"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["ORGANIZER_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["ORGANIZER_TAG"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.typeData = res.data["ORGANIZER_TYPE"];
        this.tagData = res.data["ORGANIZER_TAG"];
      });
    },
    initData() {
      //查询
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
